var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z",
    fill: "#5062F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44383 4.935V10H5.55383V4.935H6.44383ZM6.63383 3.345C6.63383 3.43167 6.61549 3.51333 6.57883 3.59C6.54549 3.66333 6.49883 3.73 6.43883 3.79C6.38216 3.84667 6.31383 3.89167 6.23383 3.925C6.15716 3.95833 6.07549 3.975 5.98883 3.975C5.90216 3.975 5.82049 3.95833 5.74383 3.925C5.67049 3.89167 5.60549 3.84667 5.54883 3.79C5.49216 3.73 5.44716 3.66333 5.41383 3.59C5.38049 3.51333 5.36383 3.43167 5.36383 3.345C5.36383 3.25833 5.38049 3.17667 5.41383 3.1C5.44716 3.02 5.49216 2.95167 5.54883 2.895C5.60549 2.835 5.67049 2.78833 5.74383 2.755C5.82049 2.72167 5.90216 2.705 5.98883 2.705C6.07549 2.705 6.15716 2.72167 6.23383 2.755C6.31383 2.78833 6.38216 2.835 6.43883 2.895C6.49883 2.95167 6.54549 3.02 6.57883 3.1C6.61549 3.17667 6.63383 3.25833 6.63383 3.345Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8cd8669ca512d80a7da4f7d4ab35c751.svg";
export { ForwardRef as ReactComponent };